import { useSelector } from "react-redux";

export const useSelectChatboxes = () => (
  useSelector(({ chats }) => ({
    chatboxes: chats.chatboxes,
    isSidebarOpen: chats.isSidebarOpen,
  }))
)
